import { useEffect } from "react";
import Reveal from "@/components/Reveal";
import LoanCalculator from "@/components/LoanCalculator";

export default function Calculator() {
  useEffect(() => {
    document.title = "Car Loan Calculator — AutoWorld";
  }, []);

  return (
    <div className="pt-16 md:pt-20" data-testid="calculator-page">
      <section className="border-b border-black/10">
        <div className="mx-auto max-w-[1400px] px-5 py-14 md:px-10 md:py-20">
          <Reveal>
            <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-neutral-500">First car? Know your number</div>
            <h1 className="mt-4 font-display font-extrabold uppercase tracking-tighter" style={{ fontSize: "clamp(2rem, 8.4vw, 4.5rem)", lineHeight: 1.02 }}>
              Monthly,<br /><span className="text-stroke">Demystified.</span>
            </h1>
            <p className="mt-4 max-w-md text-neutral-600">
              Slide, see, decide. Then send the numbers straight to us on WhatsApp — we'll match it with our best direct deal.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-5 py-14 md:px-10 md:py-24">
        <Reveal>
          <LoanCalculator dark />
        </Reveal>
      </section>
    </div>
  );
}
